import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import awsconfig from './awsconfig';

Amplify.configure({
  ...awsconfig,
  Storage: {
    S3: {
      bucket: awsconfig.Storage?.S3?.bucket,
      region: awsconfig.Storage?.S3?.region,
      prefixResolver: async ({ accessLevel }) => {
        const { identityId } = await fetchAuthSession();
        if (accessLevel === 'private')   return `private/${identityId}/`;
        if (accessLevel === 'protected') return `protected/${identityId}/`;
        return 'public/';
      }
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
  );

reportWebVitals();
